import { SupportTicketStatus } from 'src/app/models/support-ticket.model';

export const SUPPORT_TICKET_PAGE_SIZE = 10;
export const SUPPORT_TICKET_MAX_FILE_SIZE = 5 * 1024 * 1024;
export const SUPPORT_TICKET_MAX_DESCRIPTION_LENGTH = 1500;

export const SUPPORT_TICKET_STATUS_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Received', value: SupportTicketStatus.Received },
  { label: 'Work-In-Progress', value: SupportTicketStatus.WorkInProgress },
  { label: 'Completed', value: SupportTicketStatus.Completed },
];